<template>
	<div class="Login">
		<el-container>
		  <el-main>
			<el-form :label-position="labelPosition" :rules="rules" ref="ruleForm" label-width="80px" :model="ruleForm">
				<h3 class="title">用户登录</h3>
			  <el-form-item label="手机号" prop="userMobile">
			    <el-input v-model.number="ruleForm.userMobile" @keyup.enter.native="submitForm('ruleForm')" auto-complete="off" placeholder="请输入手机号" :maxlength="11"></el-input>
			  </el-form-item>
			  <el-form-item label="验证码" prop="captcha">
			    <input v-model="ruleForm.captcha" placeholder="请输入验证码" @keyup.enter="submitForm('ruleForm')" id="code" :maxlength="6"></input>
          		<span type="primary"  @click="sendCode" v-if="codeMsg=='发送验证码'" class="sendcode el-button el-button--primary bb">{{codeMsg}}</span>
          		<el-button type="primary" v-else disabled class="sendcode">{{codeMsg}}</el-button>
			  </el-form-item>
			  <el-form-item style="text-align: center;">
			    <el-button type="primary" @click="submitForm('ruleForm')" class="bb" style="width:100px" round>登录</el-button>
			    <a type="primary" class="el-button el-button--primary bb" @click="register" style="border-radius: 20px;width:100px;background-color: #fff;color:#44C1DE;padding: 12px 23px">注册</a>
			  </el-form-item>
			</el-form>
			
			<el-dialog
			  title="提示"
			  :visible.sync="dialogVisible"
			  width="30%">
			  <span>短信验证码已发送到您的手机！请注意查收！</span>
			  <span slot="footer" class="dialog-footer">
			    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
			  </span>
			</el-dialog>
		  </el-main>
		  
		</el-container>
		<router-view></router-view>
		<el-footer style="position:fixed;bottom:0;width:100%;text-align: center;height: 120px; font-size: 12px; color: #fff;background-color: #616b88;">
	      		<div class="backup_info" style="padding:40px 0 0px 0;">
	      			孙武击剑版权所有 | 浙ICP17020049号-1 | 
	      			<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010302003025" style="display:inline-block;text-decoration:none;line-height:20px; color: #fff;" >
	      				<img src="../assets/img/backup_icon.8240878.png" style="vertical-align: middle;float:left;margin-top: 3px;">
	      				
				 		公安备案33010302003025
	      			</a>
	      		</div>
	      		<div>
	      			<p>
	      				客服电话：17682314530
	      			</p>
	      		</div>
	      </el-footer>
	</div>
</template>

<script>
	import axios from "axios";
	export default{
		data(){
			return{
				labelPosition:"left",
				ruleForm: {
		          userMobile: '',
				  captcha:''
		       },
		   	   type:'login',
		       rules:{
		       	  userMobile: [
		            { required: true, message: '请输入手机号', trigger: 'blur' },
		            { type: 'number', message: '手机号必须为数字值'}
		          ],
		          captcha:[
		          	{ required: true, message: '请输入验证码', trigger: 'blur' },
		          ],
		       },	
		       codeMsg:'发送验证码',
		       dialogVisible:false,
			}
		},
		mounted(){
			//this.userAgent()
		},
		methods:{
			userAgent () {
				var userAgent = navigator.userAgent;
				if(userAgent.indexOf('Chrome') > -1){
				 	var agentArr = userAgent.split(" ")
				 	for(var i = 0;i < agentArr.length;i ++){
				 		if(agentArr[i].indexOf('Chrome') > -1){
				 			if(parseInt(agentArr[i].split('/')[1]) < 60){
				 				alert("请使用最新版谷歌浏览器");
				 			} 
				 		}
				 	}
				} else{
				 	alert("请选择谷歌浏览器打开")
				}
			},
			changeCaptchImg(){
			},
			register(){
				this.$router.push("/registered")
			},
			sendCode(){
				var that=this
				var postData={
					mobile:that.ruleForm.userMobile,
					type:'login'
				}
				axios.post('/marlin/sign/sms/send',postData)
				.then(function(res){
					if(res.data.code==0){
						var num=60;
						var set=	setInterval(function(){ 
								if(num>1){
								num--
								that.codeMsg=num+'s后重新发送'
								}else{
									
									clearInterval(set)
									that.codeMsg="发送验证码"
									return num=60;
								}
							}, 1000);
					}else{
						that.$message({
							message: res.data.msg,
						    type: 'warning'
						})
					}
				})
				.catch(function(res){
					
				})
			},
			submitForm(formName) {
				var self=this;
		        this.$refs[formName].validate((valid) => {
		          if (valid) {
			            var postData=self.ruleForm
			            axios.post('/marlin/sign/login/normal',postData)
			            .then(function(res){
			            		if(res.data.code==0){
					                self.$router.push("/auditMsg");
					                localStorage.setItem("userInfos",JSON.stringify(res.data.rst[0]))
			            		}else{
			            			self.$message({
						          message: res.data.msg,
						          type: 'warning'
						        });
			            		}
			            })
			            .catch(function(res){
			            })
		          } else {
			            return false;
		          }
		        });
		      },
		}
	}
</script>
<style scoped>
	.el-main{
		display: flex;
		width: 100%;
		height:500px;
		flex-direction: column;
		justify-content: center;
	}
	.el-form{
		width:450px;
		
		align-self: center;
	}
	.el-input__inner{
		width: 250px;
	}
	.title{
		text-align: center;
	}
	.name input{
		width: 100%;
	}
	#code{
		width:240px;
		-webkit-appearance: none;
	    background-color: #fff;
	    background-image: none;
	    border-radius: 4px;
	    border: 1px solid #dcdfe6;
	    -webkit-box-sizing: border-box;
	    box-sizing: border-box;
	    display: inline-block;
	    font-size: inherit;
	    height: 40px;
	    line-height: 40px;
	    outline: 0;
	    padding: 0 15px;
	}
	input::-webkit-input-placeholder{
            color:#c4c8cf;
        }
        input::-moz-placeholder{   /* Mozilla Firefox 19+ */
            color:#c4c8cf;
        }
        input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
            color:#c4c8cf;
        }
        input:-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
            color:#c4c8cf;
        }
	#code:focus{
		border-color: #409EFF;
	}
	.sendcode{
		width: 115px !important;
		padding: 12px 10px;
	}
</style>


// WEBPACK FOOTER //
// src/components/Login.vue